import PictureFill from 'picturefill'
import objectFitImages from 'object-fit-images';
import Lazysizes from 'lazysizes';

// Polyfills
PictureFill();
//objectFitImages();